import { render } from "./TreinadorForm.vue?vue&type=template&id=229054ef&scoped=true"
import script from "./TreinadorForm.vue?vue&type=script&lang=js"
export * from "./TreinadorForm.vue?vue&type=script&lang=js"

import "./TreinadorForm.vue?vue&type=style&index=0&id=229054ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229054ef"]])

export default __exports__